import { Component, EventEmitter, Input, Output } from '@angular/core';
import { Observable } from 'rxjs';
import { IdentificationProvider } from '@shared/enums/identification-provider.enum';
import { User } from '../../../auth/identification-provider.service';
import { IdentificationLMSProviderService } from '../../../auth/identification-lms-provider.service';

@Component({
  selector: 'form-identification-lms-provider',
  templateUrl: './identification-lms-provider.component.html',
  styleUrls: ['./identification-lms-provider.component.scss']
})
export class IdentificationLMSProviderComponent {
  public readonly IdentificationProvider = IdentificationProvider;
  public user$: Observable<User | null>;
  @Output() beforeLogin: EventEmitter<void> = new EventEmitter<void>();
  @Input() public providersList: IdentificationProvider[] = [IdentificationProvider.GENEVE_ID, IdentificationProvider.VAUD_ID, IdentificationProvider.TRUST_ID, IdentificationProvider.HIN, IdentificationProvider.SWISS_ID];

  constructor(
    private readonly identificationProviderService: IdentificationLMSProviderService
  ) {
    this.user$ = this.identificationProviderService.getUser();
  }

  public async login(identificationProvider: IdentificationProvider) {
    this.beforeLogin.next();
    this.identificationProviderService.login(identificationProvider);
  }

  logout(): void {
    this.identificationProviderService.logOut();
  }
}